<template>
	<div class="index" id="heade">
		<header class="head">
			<div class="con flex02">
				<img src="../../../../static/images/portal/pic_title.png" alt="" class="leftHead">
				<div class="flex02" style="margin-top: 60px;">
					<!-- <div class="searchBox">
						<input type="text" placeholder="请输入关键词">
						<div class="search"><img src="../../../../static/images/portal/icn_search.png" alt=""></div>
					</div> -->
					<div style="cursor: pointer;" @click="hydlClick()" class="loginbox" v-if="username == ''">
						<img src="../../../../static/images/portal/icon_login.png" alt="">
						<span class="logintxt">用户登录</span>
					</div>
					<div v-if="username != ''" class="user_div">
						<!-- 用户名下拉菜单 -->
						<el-dropdown class="dropdown-position" @command="handleCommand">
							<div class="el-dropdown-link" style="cursor: pointer;display: block;height: 40px;">
								<div class="peoplediv">
									<img class="people" src="../../../../static/images/portal/people.png"></img>
									<span id="realname" class="realname">{{username}}</span>
								</div>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="personal" class="iconfont icon-personal iconfontDrop">
									&nbsp;
									<span class="dropdowmtxt">个人中心</span>
								</el-dropdown-item>
								<el-dropdown-item command="logout" class="iconfont icon-logout iconfontDrop">
									&nbsp;
									<span class="dropdowmtxt">退出</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<!-- <span style="font-size: 1rem;">欢迎您，{{username}}<img class="people" src="../../../../static/images/portal/people.png" /></span> -->
					</div>
				</div>
			</div>
		</header>

		<!--登录-->
		<div id="loginDialog">
			<el-dialog :title=dialogtitle :visible.sync="LoginFormVisible" :close-on-click-modal="false">
				<LoginDom></LoginDom>
			</el-dialog>
			<div id="some-div" style="display:none;"></div>
		</div>
	</div>
</template>
<script>
	//引入Header Component
	import LoginDom from '@/views/portal/layout/Login'
	var code; //在全局定义验证码
	var officeHandshake = null;
	import {
		Encrypt,
		Decrypt
	} from '@/common/js/secret.js'
	export default {
		data() {
			return {
				isrc: '',
				currentUser: JSON.parse(localStorage.getItem('CURRENTUSER')),
				LoginFormVisible: false,
				dialogtitle: "用户登录",
				username: "",
				url:"/#/home"
			};
		},
		components: {
			LoginDom,
		},
		watch: {
			dialogtitle(newName, oldName) {
			},
		},
		created() {},
		mounted() {
			if (this.currentUser != null) {
				this.username = this.currentUser.realname
				if(this.currentUser.realname == null || this.currentUser.realname == ""){
					this.username = this.currentUser.username
				}
			}
		},
		methods: {
			hydlClick: function(type) {
				this.LoginFormVisible = true;
			},
			//用户名下拉菜单选择事件
			handleCommand(command) {
				if ("personal" == command) {
					this.personal();
				} else if ("logout" == command) {
					this.logout();
				}
			},
			//退出
			logout() {
				let vm = this;
				vm.$confirm('是否退出', '提示', {
					confirmButtonText: '是',
					cancelButtonText: '否',
					type: 'warning'
				}).then(() => {
					vm.$axios.get("/logout").then(function(res) {
							// if ((res.data.code = "00000000")) {
							localStorage.removeItem("isLogin");
							localStorage.removeItem("XTOKEN");
							localStorage.removeItem("CURRENTUSER");
							localStorage.removeItem("MENUS");
							this.username = "";
							this.CONSTANT.currentUser = null
						}.bind(this),
						function(error) {
							console.log(error);
						}
					);
				}).catch(() => {});
			},
			//个人中心Click
			personal: function() {
				window.open(window.config.frontUrl+"/#/home","_blank")
			},
		},
		computed: {
			onRoutes() {
				var routePath = this.$route.path;
				if (this.$route.matched.length > 3) {
					routePath = this.$route.matched[2].path;
				} else if (this.$route.matched.length == 3 && !this.$route.matched[2].path.endsWith('/')) {
					routePath = this.$route.matched[1].path;
				}
				if (routePath.endsWith('/')) {
					routePath = routePath.substr(0, routePath.length - 1);
				}
				for (var i in this.parMenus) {
					if (routePath == this.parMenus[i].resourcename) {
						this.subMenus = this.parMenus[i].children;
						return routePath;
					} else {
						if (this.parMenus[i].children != null) {
							for (var j in this.parMenus[i].children) {
								if (routePath == this.parMenus[i].children[j].resourcename) {
									this.subMenus = this.parMenus[i].children;
									return this.parMenus[i].resourcename;
								} else {
									if (this.parMenus[i].children[j].children != null) {
										for (var k in this.parMenus[i].children[j].children) {
											if (routePath == this.parMenus[i].children[j].children[k].resourcename) {
												this.subMenus = this.parMenus[i].children;
												return this.parMenus[i].resourcename;
											}
										}
									}
								}
							}
						}
					}
				}
			},
			onSubMenus() {
				return this.subMenus;
			}
		}
	};
</script>
<style lang="scss">
	.index {
		width: calc(100vw - 5px);
		min-width: 1200px;
	}

	#heade {

		.head {
			width: 100%;
			height: 160px;
			background: url("../../../../static/images/portal/bg_title.png") 100% 100%;
		}


		.flex01 {
			display: flex;
			justify-content: space-around;
		}

		.flex02 {
			display: flex;
			justify-content: space-between;
		}

		.leftHead {
			width: 520px;
			// height: 68px;
			margin-top: 46px;
		}

		.con {
			width: 1200px;
			margin: 0 auto
		}

		.searchBox {
			width: 250px;
			height: 42px;
			line-height: 40px;
			border-radius: 20px;
			border: 1px solid #ffffff;
			position: relative;
		}

		.searchBox input {
			border: none;
			height: 40px;
			outline: none;
			padding-left: 20px;
			color: #ffffff !important;
			font-size: 14px;
			background: none;
		}

		.search {
			position: absolute;
			top: 0;
			right: -1px;
			border-radius: 0 20px 20px 0;
			background: #ffffff;
			text-align: center;
			width: 50px;
			height: 40px;
		}

		.search img {
			vertical-align: middle;
			margin-top: -3px;
			// line-height: 30px;
		}

		.loginbox {
			width: 140px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			background: #ffffff;
			color: #1243cb;
			margin-left: 40px;
			border-radius: 20px;
			font-size: 14px;
		}

		.loginbox img {
			display: inline-block;
			vertical-align: middle;
			margin-top: -1px;
		}

		.logintxt {
			display: inline-block;
			vertical-align: middle;
			margin-left: 5px;
			margin-top: -1px;
		}

		.el-dialog {
			width: 500px;
		}

		.login-btn {
			width: 100%;
			margin-top: 20px;
		}

		.buttonSubmit {
			margin-top: 10px;
			padding: 0 20px;
		}

		.el-button {
			width: 100%;
			height: 40px;
		}

		.btn_login {
			background-color: #1243cb;
			color: #ffffff;
			font-size: 16px;
		}

		.btn_regist {
			margin-top: 20px;
			color: #1243cb;
			font-size: 16px;
			border: 1px solid #1243cb;
		}

		.line {
			margin-top: 20px;
			width: 100%;
			height: 2px;
			background-color: #DDDDDD;
		}

		.el-form-item__error {
			margin-top: 5px;
		}

		.verification1 {
			width: 7.125rem;
			height: 40px;
			border: none;
			border-radius: .3125rem;
			font-size: 1.75rem;
			color: #F89E19;
			font-family: 'PingFangRegular';
			text-shadow: 0.05em 0.05em 0.3em #333333;
			float: right;
		}

		.code {
			width: 110px;
			border: 1px solid #DDDDDD;
			text-align: center;
		}

		.user_div {
			margin-left: 40px;
		}

		.peoplediv {
			height: 40px;
		}

		.peoplediv img {
			display: inline-block;
		}

		.realname {
			color: #ffffff;
			display: inline-block;
			vertical-align: top;
			line-height: 40px;
			font-size: 16px;
			margin-left: 5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/portal/layout/Header.vue